<template>
  <a @click.stop.prevent="message" class="boutonRond messageRond">
    <img :src="'/assets/icons_' + $store.state.iconTheme + '/mail.png'" />
  </a>
</template>

<script>
export default {
  name: "MessageButton",
  props: {
    profile: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    async message() {
      if (this.disabled) {
        await alert(
          "Votre profil est en cours de modération !<br/<br/>" +
            "Vous pourrez envoyer des messages une fois votre profil vérifié."
        );
      } else {
        this.$router.push(this.to);
      }
    }
  },

  computed: {
    to: function() {
      const res = {
        name: "Messagerie",
        query: {
          id: this.profile.id
        },
        params: {
          profile: this.profile
        }
      };
      return res;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";
</style>
